import React from 'react';
import { Switch } from 'antd';

interface Props {
  id?: string;
  value?: boolean;
  onChange?: (value: boolean) => void;
}

const HideFilter = (props: Props) => {
  const { id, value, onChange } = props;

  return (
    <div id={id}>
      <Switch
        checked={Boolean(value)}
        onChange={(data) => {
          onChange?.(data);
        }}
      />
      <span style={{ marginLeft: '8px' }}>For Conviva internal view only</span>
    </div>
  );
};

export default React.memo(HideFilter);
